export enum IconFormatEnum {
    MAT_ICON = 'MatIcon',
    SVG_ICON = 'SvgIcon',
    FABRIC_ICON = 'FabricIcon' //TEAMS-424: KLW - Add another icon type for the Fabric Icons
}
